import { render, staticRenderFns } from "./PackageProductDialog.vue?vue&type=template&id=94b87bce&scoped=true"
import script from "./PackageProductDialog.vue?vue&type=script&lang=js"
export * from "./PackageProductDialog.vue?vue&type=script&lang=js"
import style0 from "./PackageProductDialog.vue?vue&type=style&index=0&id=94b87bce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94b87bce",
  null
  
)

export default component.exports